import React from 'react';
import { connect } from 'react-redux';
import Textarea from 'react-textarea-autosize';

import mapActionsToDispatchToProps from 'utils/core/mapActionsToDispatchToProps.util';

import { changeBookingNotes } from 'booking/actions';

class BookingNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBookingNotes: true,
      currentNotes: this.props.notes,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ currentNotes: nextProps.notes });
  }

  render() {
    const { changeBookingNotes } = this.props;
    const { currentNotes, showBookingNotes } = this.state;

    const handleBlur = (ev) => void changeBookingNotes(ev.target.value);
    const handleChange = (ev) => void this.setState({ currentNotes: ev.target.value });

    if (!showBookingNotes) {
      return <div data-bem="BookingNotes--hidden"></div>;
    }

    return (
      <div data-bem="BookingNotes--shown">
        <Textarea
          style={{ resize: 'vertical' }}
          className="note"
          onBlur={handleBlur}
          onChange={handleChange}
          value={currentNotes}
        />
      </div>
    );
  }
}

const BookingNotesHoc = connect(
  (state) => ({
    notes: state?.booking?.notes,
  }),
  mapActionsToDispatchToProps({
    changeBookingNotes,
  }),
)(BookingNotes);

export default BookingNotesHoc;
